/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
export enum GoalTransactionPaymentMethod {
  TRANSFER = 0,
  CHECK = 1,
  NONE = 2,
  REFERRAL = 3,
  REBALANCE = 4,
  REINVEST = 5,
  DIRECTTRANSFER = 6,
  REDISTRIBUTION = 7
}
